module.exports = __webpack_public_path__ + "img/cart-buy-hen.13f48e51.png";